import { Router, Routes } from '@angular/router';
import { inject } from '@angular/core';
import { SEARCH_CONTROL_PROVIDER } from '@tokens/search-contorl.token';
import { canViewByPermission } from './core/permissions/can-active/can-view-permission';
import { FeatureFlagsService } from './core/services/feature-flags/feature-flags.service';
import { AdminsComponent } from './pages/application-admins/application-admins.component';
import { CompanyApiService } from './pages/companies/components/create-company/services/company-api.service';
import { UserFormService } from './pages/companies/components/invite-dialog-user/service/user-form.service';
import { UsersService } from './pages/companies/components/users-list/services/users/users.service';
import { CompanyStateService } from './pages/companies/services/company-state.service';
import { GeneralFormService } from './pages/companies/services/general-form.service';
import { AnalyticsSummaryService } from './pages/analytics-summary/services/analytics-summary.service';
import { LogPageComponent } from './pages/log-page/log-page.component';
import { LogAdminFieldsService } from './pages/log-page/services/log-admin-fields/log-admin-fields.service';
import { LogService } from './pages/log-page/services/log/log.service';
import { UserProfileFormService } from './pages/user-profile/services/user-form/user-profile-form.service';
import UserProfileComponent from './pages/user-profile/user-profile.component';

export const CORE_ROUTES: Routes = [
  { path: 'admin/companies', redirectTo: '/companies', pathMatch: 'full' },
  { path: '', redirectTo: 'companies', pathMatch: 'full' },
  {
    path: 'companies',
    loadChildren: () => import('./pages/companies/routes').then((r) => r.COMPANIES_ROUTES),
    title: 'Companies',
    providers: [GeneralFormService, CompanyApiService, CompanyStateService, SEARCH_CONTROL_PROVIDER],
  },
  {
    path: 'application-admins',
    component: AdminsComponent,
    title: 'Application users',
    providers: [
      GeneralFormService,
      UserFormService,
      UsersService,
      CompanyStateService,
      CompanyApiService,
      SEARCH_CONTROL_PROVIDER,
    ],
    canMatch: [canViewByPermission('superUserRole', ['/'])],
  },
  {
    path: 'user',
    component: UserProfileComponent,
    providers: [UsersService, CompanyApiService, UserProfileFormService],
  },
  {
    path: 'log',
    title: 'Log page',
    component: LogPageComponent,
    providers: [
      LogService,
      CompanyApiService,
      CompanyStateService,
      GeneralFormService,
      SEARCH_CONTROL_PROVIDER,
      LogAdminFieldsService,
    ],
  },
  {
    path: 'analytics',
    loadComponent: () => import('./pages/analytics-summary/analytics-summary.component'),
    title: 'Analytics',
    providers: [AnalyticsSummaryService, GeneralFormService, CompanyStateService, SEARCH_CONTROL_PROVIDER],
    canMatch: [() => inject(FeatureFlagsService).isEnabled('analytics') || inject(Router).createUrlTree(['/'])],
  },
  {
    path: 'docs',
    loadComponent: () => import('./pages/docs/docs.component'),
    loadChildren: () => import('./pages/docs/docs.routes').then((r) => r.DOCS_ROUTES),
    title: 'Documentation',
  },
];
